<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="17"
      cy="17"
      r="17"
      fill="#5061FA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.8334 7.8335H16.1667V16.1668H7.83337V17.8335H16.1667V26.1668H17.8334V17.8335H26.1667V16.1668H17.8334V7.8335Z"
      fill="white"
    />
  </svg>
</template>
